import { FC, ReactNode, useState, useEffect } from 'react';
import { translate } from 'translations';
import { useDispatch } from 'react-redux';
import { getLogoNameBrandName } from 'utils';
import { setCustomBrandName } from '@redux/slices/userSlice';
import mapCustomBrandNameToTenant from 'utils/mapCustomBrandNameToTenant';
import styles from './loginWrapper.module.scss';

const LoginWrapper: FC<LoginWrapperProps> = (props: LoginWrapperProps) => {
    const dispatch = useDispatch();
    const { children, width = '25.43rem', height = '30.75rem', showEula, isLogin, paddingRight = '2rem' } = props;
    const [customBrandNameLocal, setCustomBrandNameLocal] = useState<string | undefined>(undefined);
    const isOwasp = window.location.host.split('.')[0] === 'owasp';

    useEffect(() => {
        const tenantName = window.location.host.split('.')[0];
        const customBrandName = mapCustomBrandNameToTenant(tenantName);
        if (['develop', 'dev'].includes(String(process.env.CB_ENV)) && tenantName) {
            dispatch(setCustomBrandName(customBrandName));
        }
        setCustomBrandNameLocal(customBrandName);
    }, []);

    const imageName = getLogoNameBrandName(customBrandNameLocal || undefined);

    return (
        <div className={styles['login-wrapper']}>
            <div className={styles.top}>
                <img
                    alt="logo"
                    className={styles['def-image']}
                    src={`${process.env.PUBLIC_URL}/images/CheckmarksLogo.svg`}
                />
                {isOwasp && (
                    <img
                        className={styles['owasp-image']}
                        alt="logo"
                        src={`${process.env.PUBLIC_URL}/images/owaspLogov2.svg`}
                    />
                )}
            </div>
            <div className={styles.body}>
                <div className={styles.text}>
                    <div className={styles.titles}>
                        <div className={styles['welcome-text']}>{translate('WelcomeTo')}</div>
                        {customBrandNameLocal !== undefined && (
                            <img
                                className={styles.logo}
                                alt="logo"
                                src={`${process.env.PUBLIC_URL}/images/${imageName}.svg`}
                            />
                        )}
                    </div>
                    {customBrandNameLocal !== undefined && (
                        <div className={styles['bottom-text-wrapper']}>
                            <div className={styles['cb-text']}>{translate('LearningPanel_WelcomeText')}</div>
                            <div className={styles['login-text-subtitle-and-link']}>
                                <br />
                                <div className={styles['click-here-text']}>
                                    <a href="https://codebashing.com">{translate('ClickHere')}</a>
                                </div>

                                {showEula && !isOwasp && (
                                    <>
                                        <div className={styles['eula-link']}>{translate('TermsOfUse')}</div>
                                        <div className={styles['eula-link-site']}>
                                            <a href="https://checkmarx.com/legal/terms">
                                                {translate('TermsOfUseLink')}
                                            </a>
                                        </div>
                                    </>
                                )}
                                {isOwasp && (
                                    <div className={styles.owasp}>
                                        <div className={styles.inlineLink}>
                                            {isLogin ? translate('ClickingLogin') : translate('ClickingCreateAccount')}
                                        </div>
                                        <a
                                            className={styles.inlineLink}
                                            href="https://checkmarx.com/legal/checkmarx-terms-of-service/"
                                        >
                                            {translate('TermsOfUseLink')}
                                        </a>
                                        <div className={styles.inlineLink}>and</div>
                                        <a
                                            className={styles.inlineLink}
                                            href="https://checkmarx.com/legal/checkmarx-external-privacy-policy/"
                                        >
                                            {translate('PrivacyPolicy')}
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles.form} style={{ width, height, paddingRight }}>
                    {children}
                </div>
            </div>
        </div>
    );
};

interface LoginWrapperProps {
    children?: ReactNode;
    width?: string;
    height?: string;
    showEula?: boolean;
    customBrandNameLoaded?: boolean;
    customBrandName?: string;
    isLogin?: boolean;
    paddingRight?: string;
}

export default LoginWrapper;
